<template>
  <OverflowList
    class="notification-recipient-chips"
    :items="items"
    :visible-count="visibleCount"
    position="bottom"
    fixed
    :data-testid="dataTestid"
  >
    <template #primary="{ item, index }">
      <FcTooltip
        :text="recipientLabel(item)"
        placement="bottom"
        fixed
        eager
        transition="fade-transition"
        :open-delay="0"
        :data-testid="`${dataTestid}-tooltip--${index}`"
      >
        <FcUserAvatar
          :name="recipientName(item)"
          :email="recipientEmail(item)"
          :size="24"
          :data-test-id="`${dataTestid}-avatar--${index}`"
        />
      </FcTooltip>
    </template>
  </OverflowList>
</template>

<script>
import OverflowList from '../../OverflowList/OverflowList.vue';
import FcTooltip from '../../FcTooltip/FcTooltip.vue';
import FcUserAvatar from '../../FcUserAvatar/FcUserAvatar.vue';

function asText(value) {
  return value == null ? '' : String(value).trim();
}

export default {
  name: 'NotificationRecipientChips',
  components: { OverflowList, FcTooltip, FcUserAvatar },
  props: {
    items: { type: Array, default: () => [] },
    visibleCount: { type: Number, default: 3 },
    dataTestid: { type: String, default: 'notification-recipient-chips' },
  },
  methods: {
    recipientLabel(item) {
      if (item && typeof item === 'object') {
        return asText(item.name || item.displayname || item.email || item.contactemail);
      }
      return asText(item);
    },
    recipientName(item) {
      if (item && typeof item === 'object') {
        return asText(item.name || item.displayname);
      }
      const label = this.recipientLabel(item);
      return label.includes('@') ? '' : label;
    },
    recipientEmail(item) {
      if (item && typeof item === 'object') {
        return asText(item.email || item.contactemail);
      }
      const label = this.recipientLabel(item);
      return label.includes('@') ? label : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NotificationRecipientChips.scss';
</style>
